"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
/* Number of employeess at company */
const CompanySize = [
    'Individual use',
    '2-10',
    '11-50',
    '51-100',
    '101-500',
    '501-1000',
    '1001+',
];
/* Who referred workspace creator to Air */
const ReferralSource = [
    'Referred by someone',
    'Social media',
    'Advertisement',
    'Podcast',
    'Blog or publication',
    'Event (virtual or IRL)',
    'Search engine',
    'Newsletter/Email',
    'Other',
];
/** Account creator's role at company */
const Role = [
    'Marketing',
    'Creative',
    'Operations',
    'Executive Leadership',
    'Account / Project Management',
    'Other',
];
/** Sector of company */
const WorkspaceUse = [
    'E-commerce / Direct to Consumer',
    'Agency',
    'Education',
    'Sports and Athletics',
    'Non-Profit',
    'Technology / Software',
    'Hospitality',
    'Real Estate',
    'Food and Beverage',
    'Media and Entertainment',
    'Other',
];
const PurposeOfUse = [
    'Centralize and organize content',
    'Provide a source of truth for brand assets',
    'Manage internal & external collaboration',
    'Improve project management efficiency',
    'Control rights and access to content',
    'Other',
];
// Reference for questions: https://www.notion.so/airinc/Product-Signup-Question-Addition-Emp-Size-1f7daa2f164d433499cdc883c06563d6
const Onboarding = {
    CompanySize,
    ReferralSource,
    Role,
    WorkspaceUse,
    PurposeOfUse,
};
exports.Constants = {
    Onboarding,
};
//# sourceMappingURL=constants.js.map